import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Center,
    Tooltip,
} from '@mantine/core';

import { NARROW_COLUMN_STYLES } from './columns/constants';
import useColDeleteSchema from './columns/useColDeleteSchema';
import useColLinkSchema from './columns/useColLinkSchema';
import { PROJECT_ICONS, STATUSES } from '../../../const';
import time from '../../../utils/time';

const ICON_STYLE = {
    width: '20px',
};

const getPublishedStyles = (status) => ({
    color: STATUSES[status].color,
    transition: 'all .3s ease',
    fontSize: '24px',
    lineHeight: 0,
});

export default function useStorySchema({
    project, withProject, onDelete,
}) {
    const colDeleteSchema = useColDeleteSchema({ project, onDelete });
    const colTitleSchema = useColLinkSchema({
        type: 'title',
        accessor: 'title',
        title: 'Заголовок',
        defaultData: 'Без названия',
    });

    const storySchema = [
        {
            accessor: 'status',
            style: NARROW_COLUMN_STYLES,
            render: ({ currentData }) => (
                <Center>
                    <Tooltip label={STATUSES[currentData].label}>
                        <span style={getPublishedStyles(currentData)}>
                            &#x25cf;
                        </span>
                    </Tooltip>
                </Center>
            ),
        },
        ...(withProject ? [{
            accessor: 'project',
            style: NARROW_COLUMN_STYLES,
            render: ({ currentData }) => (
                <Center>
                    <img src={PROJECT_ICONS[currentData]} alt={currentData} style={ICON_STYLE} />
                </Center>
            ),
        }] : []),
        colTitleSchema,
        {
            accessor: 'created_at',
            title: 'Добавление',
            render: ({ currentData }) => time(currentData),
        },
        {
            accessor: 'modified_at',
            title: 'Редактирование',
            render: ({ currentData }) => time(currentData),
        },
        {
            accessor: 'published_at',
            title: 'Публикация',
            render: ({ currentData }) => time(currentData),
        },
        {
            accessor: 'views',
            title: <FontAwesomeIcon icon="eye" />,
        },
        colDeleteSchema,
    ];

    return storySchema;
}
